import { memoize } from "es-toolkit";

import { clipboardCommandSuggestionsProvider } from "./clipboardCommandSuggestionsProvider";
import { collapseSuggestionsProvider } from "./collapseSuggestionsProvider";
import { colorSuggestionsProvider } from "./colorSuggestionsProvider";
import { computedCommandSuggestionsProvider } from "./computedCommandSuggestionsProvider";
import { computedSuggestionsProvider } from "./computedSuggestionsProvider";
import { constantSuggestionsProvider } from "./constantSuggestionsProvider";
import { convertNodeSuggestionsProvider } from "./convertNodeSuggestionsProvider";
import { convertUnitSuggestionsProvider } from "./convertUnitSuggestionsProvider";
// // import { functionOperatorSuggestionsProvider } from "./functionOperatorSuggestionsProvider";
import { decoratorsSuggestionsProvider } from "./decoratorsSuggestionsProvider";
import { editNodeSuggestionProvider } from "./editNodeSuggestionProvider";
import { expressionDecoratorSuggestionsProvider } from "./expressionDecoratorSuggestionsProvider";
import { expressionSuggestionsProvider } from "./expressionSuggestionsProvider";
import { functionBracketsSuggestionsProvider } from "./functionBracketsSuggestionsProvider";
import { functionSuggestionsProvider } from "./functionSuggestionsProvider";
import { graphSuggestionsProvider } from "./graphSuggestionsProvider";
import { groupSuggestionsProvider } from "./groupSuggestionsProvider";
import { inlineTextStyleSuggestionsProvider } from "./inlineTextStyleSuggestionsProvider";
import { insertMathSuggestionsProvider } from "./insertMathSuggestionsProvider";
import { latexInputSuggestionProvider } from "./latexInputSuggestionProvider";
import { librarySuggestionsProvider } from "./librarySuggestionsProvider";
import { matrixSuggestionsProvider } from "./matrixSuggestionsProvider";
import { mentionSuggestionsProvider } from "./mentionSuggestionsProvider";
import { multiSuggestionsProvider } from "./multiSuggestionsProvider";
import { notationSuggestionsProvider } from "./notationSuggestionsProvider";
import { numberSuggestionsProvider } from "./numberSuggestionsProvider";
import { operatorSuggestionsProvider } from "./operatorSuggestionsProvider";
import { operatorSymbolSuggestionsProvider } from "./operatorSymbolSuggestionsProvider";
import { placeholderSuggestionsProvider } from "./placeholderSuggestionsProvider";
import { plainTextSuggestionsProvider } from "./plainTextSuggestionsProvider";
import { powerValueSuggestionsProvider } from "./powerValueSuggestionsProvider";
import { selectionPromptSuggestionsProvider } from "./selectionPromptSuggestionsProvider";
import { serviceFunctionSuggestionsProvider } from "./serviceFunctionSuggestionsProvider";
import { slashCommandSuggestionsProvider } from "./slashCommandSuggestionsProvider";
import { sympyActionSuggestionsProvider } from "./sympyActionSuggestionsProvider";
import { unitSuggestionsProvider } from "./unitSuggestionsProvider";
import { variableArgumentsSuggestionsProvider } from "./variableArgumentsSuggestionsProvider";
import { variableFunctionSuggestionsProvider } from "./variableFunctionSuggestionsProvider";
import { variableSuggestionsProvider } from "./variableSuggestionsProvider";

export const getProviders = memoize(() => {
  return [
    insertMathSuggestionsProvider,
    variableArgumentsSuggestionsProvider,
    powerValueSuggestionsProvider,
    editNodeSuggestionProvider,
    computedCommandSuggestionsProvider,
    clipboardCommandSuggestionsProvider,
    collapseSuggestionsProvider,
    colorSuggestionsProvider,
    selectionPromptSuggestionsProvider,
    inlineTextStyleSuggestionsProvider,
    plainTextSuggestionsProvider,
    numberSuggestionsProvider,
    operatorSuggestionsProvider,
    librarySuggestionsProvider,
    operatorSymbolSuggestionsProvider,
    groupSuggestionsProvider,
    decoratorsSuggestionsProvider,
    expressionDecoratorSuggestionsProvider,
    functionBracketsSuggestionsProvider,
    graphSuggestionsProvider,
    matrixSuggestionsProvider,
    variableSuggestionsProvider,
    constantSuggestionsProvider,
    functionSuggestionsProvider,
    convertNodeSuggestionsProvider,
    multiSuggestionsProvider,
    variableFunctionSuggestionsProvider,
    unitSuggestionsProvider,
    expressionSuggestionsProvider,
    placeholderSuggestionsProvider,
    sympyActionSuggestionsProvider,
    notationSuggestionsProvider,
    serviceFunctionSuggestionsProvider,
    slashCommandSuggestionsProvider,
    mentionSuggestionsProvider,
    latexInputSuggestionProvider,
    computedSuggestionsProvider,
    convertUnitSuggestionsProvider,
  ];
});

export const getDefaultAccept = memoize(() => {
  return getProviders()
    .filter((p) => !p.omitByDefault)
    .map((p) => p.type);
});
